import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 12.7773C14 11.3966 15.1193 10.2773 16.5 10.2773C17.8807 10.2773 19 11.3966 19 12.7773C19 13.6939 18.5067 14.4953 17.7712 14.9305C17.1374 15.3055 16.5 15.8743 16.5 16.6107V18.2773",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "16.5",
      cy: "22.2773",
      rx: "1.33333",
      ry: "1.33333",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.83335 5.39442C11.7945 4.25995 14.0714 3.61066 16.5 3.61066C23.8638 3.61066 29.8334 9.58019 29.8334 16.944C29.8334 24.3078 23.8638 30.2773 16.5 30.2773C9.13622 30.2773 3.16669 24.3078 3.16669 16.944C3.16669 14.5154 3.81598 12.2385 4.95045 10.2773",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }